// extracted by mini-css-extract-plugin
export default {"opasNewsContainer":"ResidentGuide_opasNewsContainer__K4k1A","emptyBox":"ResidentGuide_emptyBox__QJX1u"};